"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var user_store_1 = require("../../reverb-js-common/user_store");
exports.buildBlankAddressFormData = function () {
    return {
        uuid: '',
        name: '',
        streetAddress: '',
        extendedAddress: '',
        postalCode: '',
        phone: '',
        region: '',
        locality: '',
        countryCode: user_store_1.default.getState().countryCode,
        primary: false,
    };
};
exports.buildAddressFormDataFromAddress = function (address) {
    return {
        uuid: address.uuid,
        name: address.name,
        streetAddress: address.streetAddress,
        extendedAddress: address.extendedAddress,
        postalCode: address.postalCode,
        phone: address.phone,
        region: address.region,
        locality: address.locality,
        countryCode: address.countryCode,
        primary: address.primary,
    };
};
//# sourceMappingURL=address_form_data.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/addresses/address_form_data.js
// module id = W6a4
// module chunks = 20 21